var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359 1107 c-38 -29 -39 -46 -39 -467 0 -421 1 -438 39 -467 12 -9 89 -12 282 -13 l266 0 27 26 26 27 0 427 0 427 -26 27 -27 26 -266 0 c-193 -1 -270 -4 -282 -13z m521 -467 l0 -320 -240 0 -240 0 0 320 0 320 240 0 240 0 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 880 c-91 -80 -121 -261 -63 -388 36 -77 88 -127 116 -112 24 13 26 52 4 71 -8 7 -27 36 -42 63 -38 73 -38 179 0 252 15 27 34 56 42 63 22 19 20 58 -4 71 -15 8 -25 5 -53 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127 899 c-21 -12 -22 -52 -1 -70 8 -7 27 -36 42 -63 38 -73 38 -179 0 -252 -15 -27 -34 -56 -42 -63 -22 -19 -20 -58 4 -71 28 -15 80 35 116 112 24 54 28 76 28 148 1 72 -4 94 -27 145 -42 89 -87 132 -120 114z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 748 c-24 -35 -28 -52 -28 -108 0 -56 4 -73 28 -108 31 -47 68 -57 87 -22 9 16 6 29 -15 63 -14 24 -25 54 -25 67 0 13 11 43 25 67 21 34 24 47 15 63 -19 35 -56 25 -87 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 770 c-9 -16 -6 -29 15 -63 14 -24 25 -54 25 -67 0 -13 -11 -43 -25 -67 -21 -34 -24 -47 -15 -63 19 -35 56 -25 87 22 24 35 28 52 28 108 0 56 -4 73 -28 108 -31 47 -68 57 -87 22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.d299f3d61aa726a17b7220f03de76551.svg";
export { ForwardRef as ReactComponent };